export default {
    title_list: 'Администраторы',
    title_page: 'Администратор',
    title_create_page: 'Создать администратора',
    title_edit_page: 'Изменить администратора',

    filter: {
        labels: {
            first_name: 'Имя',
            last_name: 'Фамилия',
            email: 'Email',
        }
    },

    table: {
        labels: {
            id: 'ID',
            first_name: 'Имя',
            last_name: 'Фамилия',
            email: 'Email',
        }
    },

    buttons: {

    },

    form: {
        first_name: 'Имя',
        last_name: 'Фамилия',
        email: 'Email',
        password: 'Пароль',
        email_verified_at: 'Дата подтверждения email',
        last_login_at: 'Последний вход',
        language: 'Язык',
        activated: 'Активирован',
    },
}
